<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "UnitName", "label": i18n.t('component.Class.UnitName.label') },
                    { "key": "ClassName", "label": i18n.t('component.Class.ClassName.label') },
                    { "key": "ClassType", "label": i18n.t('component.Class.ClassType.label') },
                    { "key": "ProjectCode", "label": i18n.t('component.Class.ProjectCode.label') }
                ]
            },
            header() {
                return i18n.t('component.Class.recHeader')
            }
        },
        data() {

            return {
                name: "Class",
                pkColumn: "ClassId",
                parent: {}
            };
        }
    }
</script>